import { Pipe, PipeTransform, inject } from '@angular/core';
import { Nillable } from '@web/utils';
import { RouterLinkParams } from '../types/router-link-params';
import { RouteProviderService } from '../providers/route-provider.service';
import { Route } from '../enums/route';
import { RouterLink } from '../types/router-link';

@Pipe({
  name: 'routerLink',
  standalone: true,
})
export class RouterLinkPipe implements PipeTransform {
  private readonly provider = inject(RouteProviderService);

  public transform(
    route: Route,
    params: Nillable<RouterLinkParams> = null,
  ): RouterLink {
    return this.provider.routerLink(route, params);
  }
}
